import React, { useEffect, useRef, useState } from 'react'
import AppBar from '../components/app-bar'
import { Button, Box, AppBar as AppBarHistory, CircularProgress, Typography, TableContainer, makeStyles, Select, MenuItem, Divider, InputLabel, FormControl, ListItemText, Tab, Table, TableHead, TableSortLabel, TableCell, TableBody, Tooltip } from '@material-ui/core'
import { customTheme } from '../styling'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import axiosInstance from '../axios'
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import formatIcon from '../images/image/format-icon.svg'
import formatVerticalIcon from '../images/image/format-vertical.svg'
import formatHorizontalIcon from '../images/image/format-horizontal.svg'
import deleteIcon from '../images/delete-icon.svg'
import AddIcon from '@mui/icons-material/Add';
import condividiSvg from '../images/condividi.svg'
import iconDownload from '../images/audio/icon-download.svg'
import iconDownloaded from '../images/audio/icon-downloaded.svg'
import iconVoiceTrget from '../images/audio/icon-voice-target.svg'
import iconSelectLanguage from '../images/audio/icona-select-language.svg'
import iconClean from '../images/icon-clean.svg'
import worldIcon from '../images/translator/world-icon.svg'
// import DownloadIcon from '@mui/icons-material/Download'
import DownloadIcon from '@mui/icons-material/PlayForWork';
import SnackBar from '../components/snackbar'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'
import moment from 'moment'
import { Buffer } from 'buffer'
import { InsertDriveFile, Label } from '@material-ui/icons'
import { Dialog, Menu, TableRow } from '@mui/material'
import { rewriteMathToWords, toBase64 } from '../utils'
import forbidden from '../images/403.jpg'




const useStyles = makeStyles(theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(4),
    height: '100vh',
    overflow: 'auto',
  },
  title: {
    color: 'black'
  },

  textarea: {
    fontSize: '1rem',
    border: '1px solid #000',
    paddingLeft: '0.5rem',
    paddingTop: '0.5rem',
    border: 'none',
    borderColor: 'none',
    resize: 'none',
    width: '100%',
    borderRadius: 15,
    height: '53vh',
    boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}`,
    '&:focus': {
      outline: 'none !important',
      outlineColor: '#B91F26',
      border: '1px solid #ba1f26 !important'
    },
  },

  input: {
    position: 'relative',
    top: '0.5rem',
    marginLeft: '1rem',
  },
  formControl: {
    minWidth: 300, marginRight: '1.5rem',
  },
}))

const styleOfImages = [
  {
    id: 1, text: 'Libero', value: 'Libero',
  },
  {
    id: 2, text: 'Illustrazione', value: 'Create a modern flat vector illustration in a professional and clean style, using a color palette of gray, black, and red. The image should convey a finance-related theme, integrating key financial symbols such as coins, dollar signs, graphs, or other relevant elements. Design the scene against a white background with a dynamic and balanced composition, incorporating minimalist details like abstract shapes, plants, or geometric patterns. Add [USER DESCRIPTION] as part of the scene to customize the illustration. Ensure the artwork feels professional, sleek, and in a flat, approachable aesthetic, with minimal shading and clean, bold design.',
  },
  {
    id: 3, text: 'Realistico finance', value: 'Create a realistic, high-quality image with a classic finance theme. The image should depict a professional environment or financial activity, incorporating elements such as electronic devices, like smartphones, tablets, or laptops, graphs, charts, or financial data overlays in glowing or semi-transparent styles. Use a dark, elegant color scheme with accents of red, gray, and black for a professional aesthetic. Include blurred or abstract modern office surroundings or soft bokeh lighting for depth and atmosphere. Add [USER DESCRIPTION] to customize the scene. Maintain a sharp, photorealistic finish to emphasize professionalism and financial focus.',
  },
]


const languages = [
  {
    id: 1, text: 'Italiano', value: 'it',
  },
  {
    id: 2, text: 'Inglese', value: 'en',
  },
  {
    id: 3, text: 'Francese', value: 'fr',
  },
  {
    id: 4, text: 'Greco', value: 'gr',
  },
  {
    id: 5, text: 'Portoghese', value: 'pt',
  },
  {
    id: 6, text: 'Spagnolo', value: 'es',
  },
  {
    id: 7, text: 'Tedesco', value: 'de',
  }
]


const voicesTarget = [
  {
    id: 1, text: 'Gianluca Garbi', value: 'voice_1',
  },
  {
    id: 2, text: 'Ilaria Bennati', value: 'voice_2',
  },
  {
    id: 3, text: 'Voce sintetica 1_Christopher', value: 'voice_3',
  },
  {
    id: 4, text: 'Voce sintetica 2_Bill', value: 'voice_4',
  },
  {
    id: 5, text: 'Voce sintetica 3_Hanna', value: 'voice_5',
  },
]


const AudioComponent = () => {
  const [userDetails, setUserDetails] = useState(null)
  const { enqueueSnackbar } = SnackBar.Consumer()
  const classes = useStyles()
  const [generating, setGenerating] = useState(false)
  const [saving, setSaving] = useState(false)
  const [downloading, setDownloading] = useState(false)
  const [language, setLanguage] = useState('')
  const [languageAudio, setLanguageAudio] = useState('')
  const [voiceTarget, setVoiceTarget] = useState('')
  const [formatImage, setFormatImage] = useState(null)
  const [textarea, setTextarea] = useState('')
  const [imageGenerated, setImageGenerated] = useState(null)
  const [view, setView] = useState(1)
  const [zoomedImage, setZoomedImage] = useState(null)
  const [orderBy, setOrderBy] = useState('status')
  const [savedAudioModalOpen, setSavedAudioModalOpen] = useState(false)
  const [deletingAudio, setDeletingAudio] = useState(false)
  const [order, setOrder] = useState('asc')
  const [files, setFiles] = useState([])
  const inputRef = useRef(null)
  const [textToSpeechList, setTextToSpeechList] = useState([])
  const [speechToText, setSpeechToText] = useState([])
  const [speechToSpeech, setSpeechToSpeech] = useState([])
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [textToSpeechProcessing, setTextToSpeechProcessing] = useState(false)
  const [speechToTextProcessing, setSpeechToTextProcessing] = useState(JSON.parse(localStorage.getItem('speechToTextProcessing')))
  const [loading, setLoading] = useState(false)
  const [users, setUsers] = useState([])
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const openMenuUser = Boolean(anchorEl2);
  const [loadingGrant, setLoadingGrant] = useState([])
  const [showmenu, setshowmenu] = useState(null)

  
  const handleClose = () => {
    setAnchorEl2(null);
    setshowmenu(null)
  };

  const handleRemoveGrant = async (id, email) => {
    const type = view === 1 ? 'text_to_speeches' : view === 2 ? 'speech_to_texts' : 'speech_to_speeches'
    setLoadingGrant([...loadingGrant, email])
    try {
      const body = {email}
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/${type}/${id}/revoke`, body)
      const res  = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/${type}`)

      if(view === 1){
        setTextToSpeechList(res.data.payload[type].map((file) => ({...file, type:1})))
      }else if(view === 2){
        setSpeechToText(res.data.payload[type].map((file) => ({...file, type:2})))
      }else if(view === 3){
        
        setSpeechToSpeech(res.data.payload[type].map((file) => ({...file, type:3})))
      }
      
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setLoadingGrant(loadingGrant.filter((loadingGrantId) => loadingGrantId !== email))
    }
  }

  const handleAddGrant = async (id, email) => {
    const type = view === 1 ? 'text_to_speeches' : view === 2 ? 'speech_to_texts' : 'speech_to_speeches'
    setLoadingGrant([...loadingGrant, email])
    try {
      const body = {email}
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/${type}/${id}/grant`, body)
      const res  = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/${type}`)

      if(view === 1){
        setTextToSpeechList(res.data.payload[type].map((file) => ({...file, type:1})))
      }else if(view === 2){
        setSpeechToText(res.data.payload[type].map((file) => ({...file, type:2})))
      }else if(view === 3){
        setSpeechToSpeech(res.data.payload[type].map((file) => ({...file, type:3})))
      }
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setLoadingGrant(loadingGrant.filter((loadingGrantId) => loadingGrantId !== email))
    }
  }
  const initialData = async () => {
    try {
      const res1 = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/text_to_speeches`)
      const res2 = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/speech_to_speeches`)
      const res3 = await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/speech_to_texts`)


      return {
        textToSpeech: [...res1.data.payload.text_to_speeches.map((file) => ({...file, type:1}))],
        speechToSpeech: [...res2.data.payload.speech_to_speeches.map((file) => ({...file, type:2}))],
        speechToText: [...res3.data.payload.speech_to_texts.map((file) => ({...file, type:3}))],
      }

    } catch (error) {

    }
  }
  useEffect(() => {
    setLoading(true)
    initialData().then((res) => {
      setTextToSpeechList(res?.textToSpeech)
      setSpeechToSpeech(res?.speechToSpeech)
      setSpeechToText(res?.speechToText)
      setLoading(false)
    }).finally(() => {
      setLoading(false)
    })
    axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/user`, {
    }).then((res) => {
      setUserDetails(res.data.payload)

      if(res.data.payload.enable_audio_tts){
        setView(1)
      }else if(res.data.payload.enable_audio_stt){
        setView(2)
      }else if(res.data.payload.enable_audio_sts){
        setView(3)
      }
    }).catch(error => {

    })
    axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/users`, {
    }).then((res) => {
      setUsers(res.data.payload.users)
    }).catch(error => {

    })
   
  
  }, [])

  useEffect(() => {
    // Pause and clean up on unmount
    return () => {
      audio?.current?.pause();
      clearInterval(intervalRef.current);
    };
  }, []);





  const handleGenerateTextToSpeech = async () => {

    setTextToSpeechProcessing(true)
    const body = {
      "text_to_speech": {
        "language": language,
        "voice": voiceTarget,
        "tone": "default",
        "sound_level": 0,
        "speed": 1,
        "content": language==='en' ? rewriteMathToWords(textarea): textarea,
        "model_id": "eleven_multilingual_v2"
      }
    }

    console.log('body', body)

    try {

      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/text_to_speeches`, body)
      initialData().then((res) => {
        setTextToSpeechList(res?.textToSpeech)
        setSpeechToSpeech(res?.speechToSpeech)
        setSpeechToText(res?.speechToText)
      })
      enqueueSnackbar({ variant: 'success', message: 'Testo inviato correttamente' })

    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {

      setTextToSpeechProcessing(false)


    }

  }


  const handleGenerateSpeechToSpeech = async () => {
    setTextToSpeechProcessing(true)
    try {
      const f = files[0]
      const dataUrl = await toBase64(f)
      const base64 = typeof dataUrl === 'string' && dataUrl.includes(',')
        ? dataUrl.split(',')[1]
        : dataUrl

      const body = {
        speech_to_speech: {
          voice: voiceTarget,
          tone: 'default',
          sound_level: 0,
          speed: 1,
          source_audio_attributes: {
            data: base64,
            filename: f.name,
            content_type: f.type || 'audio/mpeg'
          }
        }
      }

      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/speech_to_speeches`, body)
      const res = await initialData()
      setTextToSpeechList(res?.textToSpeech)
      setSpeechToSpeech(res?.speechToSpeech)
      setSpeechToText(res?.speechToText)
      enqueueSnackbar({ variant: 'success', message: 'Audio inviato correttamente' })
    } catch (error) {
      console.error('STS error:', error?.response?.status, error?.response?.data)
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setTextToSpeechProcessing(false)
    }
  }

  const mapContentType = (type) => {
    // Rails spec usa "audio/mp3"
    if (type === 'audio/mpeg') return 'audio/mp3'
    return type || 'audio/mp3'
  }

  // const handleGenerateSpeechToText = async () => {
  //   if (!files.length) return
  //   setTextToSpeechProcessing(true)
  //   try {
  //     const f = files[0]
  //     const dataUrl = await toBase64(f)
  //     const base64 = typeof dataUrl === 'string' && dataUrl.includes(',')
  //       ? dataUrl.split(',')[1]
  //       : dataUrl

  //     // Envie no ROOT (sem speech_to_text) para casar com os specs
  //     const body = {
  //       filename: f.name,
  //       content_type: mapContentType(f.type),
  //       data: base64
  //     }

  //     await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/speech_to_texts`, body)
  //     const res = await initialData()
  //     setTextToSpeechList(res?.textToSpeech)
  //     setSpeechToSpeech(res?.speechToSpeech)
  //     setSpeechToText(res?.speechToText)
  //     enqueueSnackbar({ variant: 'success', message: 'Audio inviato correttamente' })
  //   } catch (error) {
  //     console.error('STT error:', error?.response?.status, error?.response?.data)
  //     enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
  //   } finally {
  //     setTextToSpeechProcessing(false)
  //   }
  // }


  const handleGenerateSpeechToText = async () => {
    if (!files.length) return
    setTextToSpeechProcessing(true)
    try {
      const f = files[0]
      const dataUrl = await toBase64(f)
      const base64 = typeof dataUrl === 'string' && dataUrl.includes(',')
        ? dataUrl.split(',')[1]
        : dataUrl

      const body = {
        filename: f.name,
        content_type: mapContentType(f.type),
        data: base64
      }

      await axiosInstance.post(
        `${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/speech_to_texts`,
        body // JSON root-level
      )

      const res = await initialData()
      setTextToSpeechList(res?.textToSpeech)
      setSpeechToSpeech(res?.speechToSpeech)
      setSpeechToText(res?.speechToText)
      enqueueSnackbar({ variant: 'success', message: 'Audio inviato correttamente' })
    } catch (error) {
      console.error('STT backoffice error:', error?.response?.status, error?.response?.data)
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setTextToSpeechProcessing(false)
    }
  }


  const handleFileUpload = (e) => {
    const filesRaw = Array.from(e.target.files)
    if (!filesRaw) return
    setFiles(filesRaw)

  }

  const handleClickFileUpload = (e) => {
    e.preventDefault()
    if (!inputRef || !inputRef.current) return
    inputRef.current.click()
  }


  const handleSort = (orderBy) => {
    const array = view === 1 ? textToSpeechList : view === 2 ? speechToText : speechToSpeech
    setOrder(order === 'asc' ? 'desc' : 'asc')
    setOrderBy(orderBy)
    const sorded = array.sort((valueA, valueB) => {
      if (order === 'asc') {
        if (valueA[orderBy] < valueB[orderBy]) {
          return -1
        }
        if (valueA[orderBy] > valueB[orderBy]) {
          return 1
        }
        return 0
      }
      if (order === 'desc') {
        if (valueA[orderBy] > valueB[orderBy]) {
          return -1
        }
        if (valueA[orderBy] < valueB[orderBy]) {
          return 1
        }
        return 0
      }

    })
    view === 1 ? setTextToSpeechList(sorded) : view === 2 ? setSpeechToText(sorded) : setSpeechToSpeech(sorded)
  }


  const handleDownload = (fileUrl, filename, content=null) => {

    if (content) {

      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
      element.setAttribute('download', filename.replace('.mp3', '.txt'));

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    } else {
      axiosInstance.get(fileUrl, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data])
          const downloadUrl = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = downloadUrl
          link.download = filename
          link.click()
          URL.revokeObjectURL(downloadUrl)

        })
        .catch(console.error)
    }

  }


  const audio = useRef(null);
  const [playing, setPlaying] = useState(null);

  const intervalRef = useRef();

  const startTimer = () => {
    // Clear any timers already running
    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      if (audio?.current?.ended) {
        handlePause()
      }
    }, [1000]);
  };

  useEffect(() => {
    if(audio.current){
      if(playing) {
        audio.current.play()
        startTimer()
       } else { 
        audio?.current?.pause()
       }
    }
      
    },
    [playing]
  );

  const handlePause = () => {
    audio.current && audio?.current?.pause()
    audio.current = null
    setPlaying(null)
  }

  
  const handlePlay = (fileUrl, filename) => { 
    handlePause()
    axiosInstance.get(fileUrl, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data])
        const downloadUrl = URL.createObjectURL(blob)
        audio.current = new Audio(downloadUrl)
        setPlaying(fileUrl)

      })
      .catch(console.error)

  }

  const handleSave = async (file) => {
    try {
      const fileSaved = await view === 1 ? axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/text_to_speeches/${file.id}/archive`) : view === 2 ? axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/speech_to_texts/${file.id}/archive`) : axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/speech_to_speeches/${file.id}/archive`)
      const res = await initialData() 
      setTextToSpeechList(res?.textToSpeech)
      setSpeechToSpeech(res?.speechToSpeech)
      setSpeechToText(res?.speechToText)
      
      enqueueSnackbar({ variant: 'success', message: 'File salvato correttamente' })
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    }
  }

  const handleDeleteArchive = async() => {
    
    setDeletingAudio(true)
    try {
      const url = openDeleteModal.type === 1 ? 'text_to_speeches' : openDeleteModal.type === 2 ? 'speech_to_speeches' : 'speech_to_texts'
      await axiosInstance.delete(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/${url}/${openDeleteModal.id}`)
      enqueueSnackbar({variant:'success', message:'File eliminato correttamente'})
      setOpenDeleteModal(null)
      initialData().then((res) => {
        setTextToSpeechList(res?.textToSpeech)
        setSpeechToSpeech(res?.speechToSpeech)
        setSpeechToText(res?.speechToText)
      })

    } catch (error) {
        enqueueSnackbar({variant:'error', message:INTERNAL_SERVER_ERROR_MESSAGE})
    }finally{
      setDeletingAudio(false)
    }
    
  } 

  

  return (
    <AppBar>
      {((!userDetails?.enable_audio_sts && !userDetails?.enable_audio_stt && !userDetails?.enable_audio_tts) && !loading) ?  <Box id="coming-soon" style={{ 
          background: 'white',

           backgroundImage: `url(${forbidden})`, backgroundSize: '50%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', width: '100%' }} /> :
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {loading ? <Box style={{ position:'absolute', top:'50%', left:'50%'}}><CircularProgress /></Box> :
        <>
        {/* <Typography className={classes.title} style={{ float: 'left' }} variant="h5" gutterBottom component="h2">
          Audio
        </Typography> */}
        
        <TableContainer>
          <Box style={{ float: 'right' }}>
            <Box style={{ display: 'flex', flexDirection: 'row', }}>
              {(textarea || files.length > 0) &&
                <Box onClick={() => {
                  setTextarea('')
                  setFiles([])


                }} style={{ color: customTheme.colors.ui.red, marginRight: '1rem', cursor: 'pointer', fontSize: '1.1rem' }}><img style={{ position: 'relative', top: '0.3rem' }} src={iconClean} /> Pulisci</Box>
              }

              <Box onClick={() => setSavedAudioModalOpen(true)} style={{ textDecoration: 'underline', marginRight: '1rem', cursor: 'pointer', fontSize: '1.1rem' }}>Archivio</Box>
            </Box>

            {openDeleteModal &&
              <Dialog  onClose={() => setOpenDeleteModal(null)} open={openDeleteModal}>
                <Box style={{ width: '400px', height: '250px', padding: '2rem', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                  <Typography variant='h5'>Conferma richiesta</Typography>
                  <Typography style={{marginTop:'1rem', fontSize:'0.9rem'}}>Vuoi davvero eliminare questo file?</Typography>
                  <Typography style={{fontSize:'0.9rem'}}>Una volta eliminato, non sarà possibile recuperarlo.</Typography>
                  <Box style={{ marginTop: '1.5rem' }}>
                  <Button color='primary'  onClick={() => handleDeleteArchive()} variant='contained'>{deletingAudio ? <CircularProgress color='secondary' size={22} /> : 'Elimina'}</Button>
                  </Box>

                </Box>
              </Dialog>
            }
            {savedAudioModalOpen &&
              <AppBarHistory style={{ marginTop: '4rem', backgroundColor: 'white', width: '60vw', height: '100%' }}>
                <Box style={{ padding: '20px', cursor: 'pointer' }}>
                  <Box style={{ display: 'flex', flexDirection: 'row', marginTop: '1rem' }}>
                    <ArrowForwardIosIcon onClick={() => setSavedAudioModalOpen(false)} style={{ color: 'black' }} />
                    <Typography style={{ color: 'black', marginLeft: '1rem' }} variant='h6'>Archivio</Typography>
                  </Box>
                  <ul style={{ listStyleType: 'none', lineHeight: 2 }}>
                    {[view === 1 ? textToSpeechList.filter(({ status }) => status === 'archived') : view === 2 ? speechToText.filter(({ status }) => status === 'archived') : speechToSpeech.filter(({ status }) => status === 'archived')].flat().map((audio) => {
                      const userDetailsFormatted = audio?.writable ? userDetails : audio?.user
                      return <Box style={{
                        width: '100%',
                        backgroundColor: 'white',
                        padding: '1rem',
                        borderRadius: 15,
                        marginBottom: '1rem',
                        boxShadow: `0 0 2px inset ${customTheme.colors.ui.greenVeryLight}`,
                        color: 'black', fontSize: '1rem', display: 'grid',
                        gridTemplateColumns: '1.6fr 1.6fr 1.6fr 1.3fr',
                        gap: '1.5rem'
                      }} key={audio.id}>
                        <Box><InsertDriveFile style={{ color: 'grey', fontSize: '1.1rem', position: 'relative', top: '0.1rem', marginRight: '0.5rem' }} />{audio.filename}</Box>
                        <Box style={{ fontSize: '0.9rem', textAlign: 'right' }}>{moment(audio.created_at).format('dd MM YYYY hh:mm')}</Box>
                        <Box style={{ display: 'flex', flexDirection: 'row' }}>
                          <Box style={{
                            marginRight: '0.5rem',
                            width: 22,
                            height: 22,
                            borderRadius: '50%',         
                            display: 'inline-flex',       
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: userDetails?.email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39',
                            color: 'white',
                            lineHeight: 1,                
                            textTransform: 'uppercase',  
                            }}>{userDetails?.first_name.slice(0, 1)}
                          </Box>
                        
                          {userDetailsFormatted?.first_name} {userDetailsFormatted?.last_name}</Box>
                        <Box style={{ textAlign: 'center' }}>
                          {audio.writable && (
                            <img
                              onClick={(event) => {
                                setAnchorEl2(event.currentTarget);
                                setshowmenu(audio.id);
                              }}
                              style={{ width: '2rem', marginRight: '0.8rem', cursor: 'pointer' }}
                              src={condividiSvg}
                            />
                          )}

                          <DownloadIcon
                            onClick={() => handleDownload(audio.file_url, audio.filename)}
                            style={{
                              marginRight: '0.8rem',
                              color: 'grey',
                              fontSize: '3rem',
                              position: 'relative',
                              top: '0.2rem',
                              cursor: 'pointer', 
                            }}
                          />

                          {audio.writable && (
                            <img
                              onClick={() => setOpenDeleteModal(audio)}
                              style={{
                                cursor: 'pointer',
                                width: '1rem',
                                position: 'relative',
                                top: '0.2rem',
                              }}
                              src={deleteIcon}
                            />
                          )}
                        </Box>
                        {showmenu === audio.id && <Menu id="basic-menu"
          anchorEl={anchorEl2}
          open={openMenuUser}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}>
                        {users.map(({id, first_name, last_name, email}) => {
                          return (first_name || last_name) && <MenuItem style={{display: 'block'}} key={id}> 
                          <Box style={{
                            float:'left',
                marginRight: '0.5rem',
                // paddingTop:'0.2rem',
                borderRadius: '50%', width: '24px', textAlign: 'center',
                height: '24px', background: email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39', color: 'white'

              }}>{first_name.slice(0, 1)}</Box>
              <Typography id="basic-menu" style={{ marginRight: '0.5rem',float:'left', }}>
                {first_name} {last_name}</Typography> {loadingGrant.includes(email) ? <CircularProgress size={12} style={{float:'right'}} /> : audio?.grantees?.find((grant) => email === grant.email) ? <img src={deleteIcon} onClick={() => handleRemoveGrant(audio.id, email)} style={{cursor:'pointer', color:customTheme.colors.ui.red, float:'right'}}   /> : <AddIcon onClick={() => handleAddGrant(audio.id, email)} style={{cursor:'pointer', color:customTheme.colors.ui.black, float:'right'}} />}
                          
                          </MenuItem>
                        })}
                        </Menu>
                    }
                      </Box>
                    })}
                  </ul>

                </Box>
              </AppBarHistory>
            }
          </Box>




          <FormControl
            className={classes.formControl}
            style={{ marginTop: '0rem' }}
            onClick={() => userDetails?.enable_audio_tts && setView(1)}
          >
            <Button
              disabled={!userDetails?.enable_audio_tts}
              variant="outlined"
              style={{
                border: view === 1 && `1px solid ${customTheme.colors.ui.red}`,
                fontWeight: view === 1 && 'bold',
                color: view === 1 && customTheme.colors.ui.red,
                boxShadow:
                  view !== 1
                    ? '0px 2px 6px rgba(0, 0, 0, 0.25)' // sombra quando NÃO está selecionado
                    : 'none', // sem sombra quando ativo
                transition: 'all 0.3s ease', // suave
              }}
            >
              Genera audio da testo
            </Button>
          </FormControl>

          <FormControl
            className={classes.formControl}
            style={{ marginTop: '0rem' }}
            onClick={() => userDetails?.enable_audio_stt && setView(2)}
          >
            <Button
              disabled={!userDetails?.enable_audio_stt}
              variant="outlined"
              style={{
                border: view === 2 && `1px solid ${customTheme.colors.ui.red}`,
                fontWeight: view === 2 && 'bold',
                color: view === 2 && customTheme.colors.ui.red,
                boxShadow:
                  view !== 2
                    ? '0px 2px 6px rgba(0, 0, 0, 0.25)'
                    : 'none',
                transition: 'all 0.3s ease',
              }}
            >
              Trasforma audio in testo
            </Button>
          </FormControl>

          <FormControl
            className={classes.formControl}
            style={{ marginTop: '0rem' }}
            onClick={() => userDetails?.enable_audio_sts && setView(3)}
          >
            <Button
              disabled={!userDetails?.enable_audio_sts}
              variant="outlined"
              style={{
                border: view === 3 && `1px solid ${customTheme.colors.ui.red}`,
                fontWeight: view === 3 && 'bold',
                color: view === 3 && customTheme.colors.ui.red,
                boxShadow:
                  view !== 3
                    ? '0px 2px 6px rgba(0, 0, 0, 0.25)'
                    : 'none',
                transition: 'all 0.3s ease',
              }}
            >
              Cambia voce ad un audio
            </Button>
          </FormControl>

          <Divider style={{marginTop:'1.5rem'}}/>



          {view === 1 ? <FormControl className={classes.formControl} style={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', borderRadius: 15, 
              // border: `1px solid ${customTheme.colors.ui.greyLight}`, padding: '1rem 1rem 2rem 1rem' 
            }} >
            <Typography style={{ marginBottom: '0rem', paddingLeft:'1rem' }}>Imposta la voce dell'audio che vuoi generare</Typography>
            <Box style={{ display: 'flex', flexDirection: 'row', }}>
              <FormControl className={classes.formControl}>

                <InputLabel className={classes.input} id="demo-simple-select-label"><Box style={{ color: (textarea && !language) && customTheme.colors.ui.red, top: '0.2rem', position: 'relative' }}><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={worldIcon} />Lingua del testo</Box></InputLabel>
                <Select
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }}
                  label={
                    <Box><img style={{ top: '0.3rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={worldIcon} />Lingua del testo</Box>
                  }
                  variant='outlined'
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={language}
                  onChange={(event) => { setLanguage(event.target.value) }}
                >
                  {languages.map(({ text, value }) => {
                    return <MenuItem  key={value} value={value}>
                      {text}
                    </MenuItem>
                  })}

                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel className={classes.input} id="demo-simple-select-label"><Box style={{ color: (textarea && !voiceTarget) && customTheme.colors.ui.red, top: '0.2rem', position: 'relative' }}><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={iconVoiceTrget} />Voce target</Box></InputLabel>
                <Select
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }}
                  label={
                    <Box><img style={{ top: '0.3rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={iconVoiceTrget} />Voce target</Box>
                  }
                  variant='outlined'
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={voiceTarget}
                  onChange={(event) => { setVoiceTarget(event.target.value) }}
                >
                  {voicesTarget.map(({ text, value }) => {
                    return <MenuItem key={value} value={value}>
                      {text}
                    </MenuItem>
                  })}

                </Select>
              </FormControl>
            </Box>
          </FormControl>
            : view === 2 ? <FormControl className={classes.formControl} style={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', 
              // borderRadius: 15, border: `1px solid ${customTheme.colors.ui.greyLight}`, padding: '1rem 0rem 1rem 1rem' 
            }} >
              <FormControl className={classes.formControl} style={{width:'100%'}}>
                <Typography className={classes.input} id="demo-simple-select-label" style={{ paddingLeft:'1rem', fontSize: '1rem', position: 'relative', right: '1rem', top: 0, marginBottom: '0rem' }}>Seleziona un audio da trasformare</Typography>
                
                <Box style={{ display:'flex', flex:1}}>
                  <FormControl className={classes.formControl} style={{minWidth:'300px'}}>
                    <InputLabel className={classes.input} id="demo-simple-select-label"><Box style={{ color: (textarea && !language) && customTheme.colors.ui.red, top: '0.2rem', position: 'relative', width:'100%' }}><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={worldIcon} />Lingua del audio</Box></InputLabel>
                    <Select
                      style={{ width:'100%' }}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left"
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left"
                        },
                        getContentAnchorEl: null
                      }}
                      label={
                        <Box><img style={{ top: '0.3rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={worldIcon} />Lingua del audio</Box>
                      }
                      variant='outlined'
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={languageAudio}
                      onChange={(event) => { setLanguageAudio(event.target.value) }}
                    >
                      {languages.map(({ text, value }) => {
                        return <MenuItem key={value} value={value}>
                          {text}
                        </MenuItem>
                      })}

                    </Select>
                  </FormControl>

                  <ListItemText onClick={handleClickFileUpload} style={{ width: '100%', marginTop: '1rem', padding: '1rem', borderRadius: 15, border: `1px solid rgba(0, 0, 0, 0.23)`, textDecoration: 'underline', cursor: 'pointer' }}><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={files.length ? iconDownloaded : iconDownload} />{files.length ? files[0].name : 'Carica un audio oppure trascinalo direttamente qui'}
                  <AddIcon style={{ color: customTheme.colors.ui.red, fontSize: '1.5rem', float:'right' }} />
                  </ListItemText>
                  <input multiple="multiple" style={{ display: 'none' }} accept="audio/*"  ref={inputRef} type='file' hidden onClick={(event) => {
                    event.target.value = null
                  }} onChange={handleFileUpload} />
                </Box>

              </FormControl>

            </FormControl> : <FormControl className={classes.formControl} style={{ marginTop: '1.5rem', display: 'flex', flexDirection: 'column', 
                // borderRadius: 15, border: `1px solid ${customTheme.colors.ui.greyLight}`, padding: '1rem 1rem 2rem 1rem' 
              }} >
              <FormControl className={classes.formControl} style={{width:'100%'}}>
                
                <Typography style={{ paddingLeft:'1rem', fontSize: '1rem', marginBottom: '0rem' }}>Seleziona un audio da trasformare</Typography>
                <Box style={{ display:'flex', flex:1, gap:'1.5rem'}}>
                  <FormControl style={{minWidth:'300px'}}>
                    <InputLabel className={classes.input} id="demo-simple-select-label"><Box style={{ top: '0.2rem', position: 'relative' }}><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={iconVoiceTrget} />Voce target</Box></InputLabel>
                    <Select
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left"
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left"
                        },
                        getContentAnchorEl: null
                      }}
                      label={
                        <Box><img style={{ top: '0.3rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={iconVoiceTrget} />Voce target</Box>
                      }
                      variant='outlined'
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={voiceTarget || ''}
                      onChange={(event) => { setVoiceTarget(event.target.value) }}
                    >
                      {voicesTarget.map(({ text, value }) => {
                        return <MenuItem key={value} value={value}>
                          {text}
                        </MenuItem>
                      })}

                    </Select>
                  </FormControl>
              

                    <ListItemText onClick={handleClickFileUpload} style={{ width: '100%', marginTop: '1rem', padding: '1rem', borderRadius: 15, border: `1px solid rgba(0, 0, 0, 0.23)`, textDecoration: 'underline', cursor: 'pointer' }}><img style={{ top: '0.2rem', position: 'relative', marginRight: '0.5rem', height: '1rem' }} src={files.length ? iconDownloaded : iconDownload} />{files.length ? files[0].name : 'Carica un audio oppure trascinalo direttamente qui'}
                      <AddIcon style={{ color: customTheme.colors.ui.red, fontSize: '1.5rem', float:'right' }} />
                    </ListItemText>
                    <input multiple="multiple" style={{ display: 'none' }} accept="audio/*"  ref={inputRef} type='file' hidden onClick={(event) => {
                      event.target.value = null
                    }} onChange={handleFileUpload} />

                  
                </Box>
              </FormControl>

            </FormControl>
          }


          <Box 
            style={{
              width: '100%', marginTop: '2rem', display: 'grid',
              gridTemplateColumns: '1fr',
              gap: '1rem',

            }}>
            <Box style={{
              display: 'grid',
              gridTemplateColumns: '1fr',
            }}>

              <Box style={{

              }}>

                {view === 1 && <><textarea placeholder='Scrivi qui il tuo testo...' value={textarea} onChange={(event) => setTextarea(event.target.value)} className={classes.textarea} style={{ padding: '16px 18px', height:'40vh' }} /></>}
                <Box style={{ width: '100%', marginTop: view === 1 && '1.5rem', textAlign: 'center' }}>
                  {view === 1 && <Button color="primary" style={{ width: '8rem', }} disabled={!textarea} onClick={() => textarea && handleGenerateTextToSpeech()} variant='contained'>{textToSpeechProcessing ? <CircularProgress color='secondary' size={22} /> : 'Genera'}</Button>}
                  {view === 2 && <Button color="primary" style={{ width: '8rem', }} disabled={!files.length} onClick={() => files.length && handleGenerateSpeechToText()} variant='contained'>{speechToTextProcessing ? <CircularProgress color='secondary' size={22} /> : 'Genera'}</Button>}
                  {view === 3 && <Button color="primary" style={{ width: '8rem', }} disabled={!files.length} onClick={() => files.length && handleGenerateSpeechToSpeech()} variant='contained'>{speechToTextProcessing ? <CircularProgress color='secondary' size={22} /> : 'Genera'}</Button>}
                </Box>
              </Box>

            </Box>


          </Box>

          {[view === 1 ? textToSpeechList : view === 2 ? speechToText : speechToSpeech].flat().length > 0 && (<Box 
            style={{
              width: '100%', marginTop: '2rem', display: 'grid',
              gridTemplateColumns: '1fr',
              gap: '1rem',

            }}>
            <Divider />
            <Box style={{
              display: 'grid',
              gridTemplateColumns: '1fr',
            }}>

              <Typography style={{fontWeight:600}}>File in coda</Typography>
              <TableContainer style={{ margin: '1rem 0 2rem 0' }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>

                        <TableSortLabel
                          style={{ color: customTheme.colors.ui.greenVeryLight }}
                          active={orderBy === 'filename'}
                          direction={orderBy === 'filename' ? order : 'asc'}
                          onClick={() => handleSort('filename')}
                        >
                          Nome del file
                        </TableSortLabel>


                      </TableCell>
                      <TableCell>
                        <TableSortLabel
                          style={{ color: customTheme.colors.ui.greenVeryLight }}
                          active={orderBy === 'created_at'}
                          direction={orderBy === 'created_at' ? order : 'asc'}
                          onClick={() => handleSort('created_at')}
                        >
                          Data di creazione
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>

                        <TableSortLabel
                          style={{ color: customTheme.colors.ui.greenVeryLight }}
                          active={orderBy === 'status'}
                          direction={orderBy === 'status' ? order : 'asc'}
                          onClick={() => handleSort('status')}
                        >
                          Stato
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {[view === 1 ? textToSpeechList : view === 2 ? speechToText : speechToSpeech].flat().map((file) => {
                      const fileUrl = view === 3 ? file?.target_audio?.file_url : file.file_url
                      const isFileValid = ['done', 'archived'].includes(file.status)
                      return ( <TableRow
                        key={file.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {view === 3 ? file?.target_audio?.filename : file.filename}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {moment(file.created_at).format('DD MMMM yyyy : hh:mm')}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {['pending', 'running'].includes(file.status) ? 'File in fase di generazione' : isFileValid ? 'File generato con successo' : 'Qualcosa è andato storto'}
                        </TableCell>
                        <TableCell component="th" scope="row" style={{display:'flex', justifyContent:'right', alignItems:'center'}}>
                          {isFileValid && (
                            <Button
                              variant="contained"
                              style={{
                                fontSize: '0.8rem',
                                border: '1px solid #138016',
                                borderColor: '#138016',
                                color: '#138016',
                                backgroundColor: '#C6DFCF',
                                fontWeight: 'bold',
                              }}
                              onClick={() => handleSave(file)}
                            >
                              Salva
                            </Button>
                          )}

                          {isFileValid && (
                            <Tooltip title="Scarica file">
                              <DownloadIcon
                                onClick={() => {
                                  handleDownload(
                                    view === 3 ? file?.target_audio?.file_url : file.file_url,
                                    view === 3 ? file?.target_audio?.filename : file.filename,
                                    view === 2 ? file.content : null
                                  );
                                }}
                                style={{
                                  cursor: 'pointer',
                                  fontSize: '2.5rem', 
                                  marginLeft: '2.5rem', 
                                  color:'#707070'
                                }}
                              />
                            </Tooltip>
                          )}

                          {isFileValid &&
                            (fileUrl === playing ? (
                              <PauseCircleIcon
                                onClick={() => handlePause()}
                                style={{
                                  cursor: 'pointer',
                                  fontSize: '2.3rem',
                                  marginLeft: '0.4rem',
                                  color:'#707070'
                                }}
                              />
                            ) : (
                              <PlayCircleIcon
                                onClick={() => handlePlay(fileUrl, view === 3 ? file?.target_audio?.filename : file.filename)}
                                style={{
                                  cursor: 'pointer',
                                  fontSize: '2.3rem',
                                  marginLeft: '0.4rem',
                                  color:'#707070'
                                }}
                              />
                            ))}

                          {!isFileValid && (<Box></Box>)}
                        </TableCell>


                      </TableRow>
                    )})
                    }
                  </TableBody>
                </Table>
              </TableContainer>

            </Box>



          </Box>
          )}
        </TableContainer>
        </>}
      </main>
}
    </AppBar>

  )
}

export default AudioComponent